export enum EPaymentType {
  CASH = 'cash',
  DATAPHONE = 'dataphone',
  DIGITAL = 'digital',
}
